/*!
{
  "name": "CSS Transitions",
  "property": "csstransitions",
  "caniuse": "css-transitions",
  "tags": ["css"]
}
!*/
var Modernizr = require('./../../lib/Modernizr.js');
var testAllProps = require('./../../lib/testAllProps.js');
  Modernizr.addTest('csstransitions', testAllProps('transition', 'all', true));




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/browsernizr/test/css/transitions.js